import MeshObjectCreator from "../../../output/assets/objects/mesh-object-creator.js";

class ThreeGLRaycastMeshObjectCreator extends MeshObjectCreator {
    constructor(meshCreator, elementIds) {
        super();
        this._meshCreator = meshCreator;
        this._elementIds = elementIds;

        this._objBaseMat = new Map();
    }

    create(geometry, material) {
        const slot = this._elementIds.allocateSlot();

        let ownMat;

        if (Array.isArray(material)) {
            ownMat = material.map(singleMat => singleMat.makeMaterial(slot));
        } else {
            ownMat = material.makeMaterial(slot);
        }

        const object = this._meshCreator.create(geometry, ownMat);
        this._elementIds.setSlotElement(slot, object);

        if (Array.isArray(material)) {
            this._objBaseMat.set(object, material.slice());
        } else {
            this._objBaseMat.set(object, material);
        }

        return object;
    }

    dispose(object) {
        const slot = this._elementIds.getElementSlot(object);
        const material = this._objBaseMat.get(object);

        if (Array.isArray(material)) {
            for (const singleMat of material) {
                singleMat.freeMaterial(slot);
            }
        } else {
            material.freeMaterial(slot);
        }

        this._objBaseMat.delete(object);

        this._meshCreator.dispose(object);
    }

    setGeometry(object, geometry) {
        this._meshCreator.setGeometry(object, geometry);
    }

    setMaterial(object, newMaterial) {
        const slot = this._elementIds.getElementSlot(object);
        const oldMaterial = this._objBaseMat.get(object);

        let ownMat;

        if (Array.isArray(newMaterial)) {
            ownMat = newMaterial.map(singleMat => singleMat.makeMaterial(slot));
            this._objBaseMat.set(object, newMaterial.slice());
        } else {
            ownMat = newMaterial.makeMaterial(slot);
            this._objBaseMat.set(object, newMaterial);
        }

        if (Array.isArray(oldMaterial)) {
            for (const singleMat of oldMaterial) {
                singleMat.freeMaterial(slot);
            }
        } else {
            oldMaterial.freeMaterial(slot);
        }

        this._meshCreator.setMaterial(object, ownMat);
    }
}

export default ThreeGLRaycastMeshObjectCreator;
